// Hamkor brendlar — biz ishlagan kompaniyalar.
// Logolar: public/assets/img/partners/*.webp

const dataPartner = [
    { name: "Grandpharm", img: "/assets/img/partners/01-grandpharm.webp" },
    { name: "QV Attraction", img: "/assets/img/partners/02-qv-attraction.webp" },
    { name: "Biolife Active", img: "/assets/img/partners/03-biolife-active.webp" },
    { name: "Befit Pro", img: "/assets/img/partners/04-befit-pro.webp" },
    { name: "W Games", img: "/assets/img/partners/05-w-games.webp" },
    { name: "Mesmer", img: "/assets/img/partners/06-mesmer.webp" },
    { name: "Atlet.uz", img: "/assets/img/partners/07-atletuz.webp" },
    { name: "GCI Uzbekistan", img: "/assets/img/partners/08-gci-uzbekistan.webp" },
    { name: "Deutsch-Usbekischer Wirtschaftsrat", img: "/assets/img/partners/09-deutsch-usbekischer-wirtschaftsrat.webp" },
    { name: "Ipsum Pathology", img: "/assets/img/partners/10-ipsum-pathology.webp" },
    { name: "LTTS Logistatrans", img: "/assets/img/partners/11-ltts-logistatrans.webp" },
    { name: "Serkon East", img: "/assets/img/partners/12-serkon-east.webp" },
    { name: "Suvmash", img: "/assets/img/partners/13-suvmash.webp" },
    { name: "Dentium", img: "/assets/img/partners/14-dentium.webp" },
    { name: "Tamerlan Marketing", img: "/assets/img/partners/15-tamerlan-marketing.webp" },
    { name: "Meritz", img: "/assets/img/partners/17-meritz.webp" },
    { name: "Block 21 Group", img: "/assets/img/partners/22-block-21-group.webp" },
    { name: "New Anibla", img: "/assets/img/partners/25-new-anibla.webp" },
    { name: "FireWise Enterprises", img: "/assets/img/partners/26-firewise-enterprises.webp" },
    { name: "Yurak Markazi", img: "/assets/img/partners/28-yurak-markazi.webp" },
    { name: "Imir-Trade Group", img: "/assets/img/partners/30-imir-trade-group.webp" },
    { name: "Oikos", img: "/assets/img/partners/36-oikos.webp" },
    { name: "Family Group", img: "/assets/img/partners/37-family-group.webp" },
    { name: "Elma", img: "/assets/img/partners/38-elma.webp" },
    { name: "Tez Lift", img: "/assets/img/partners/39-tez-lift.webp" },
    { name: "Shayana Farm", img: "/assets/img/partners/42-shayana-farm.webp" },
    { name: "Avantika", img: "/assets/img/partners/44-avantika.webp" },
    { name: "Smart Technology Systems", img: "/assets/img/partners/45-smart-technology-systems.webp" },
    { name: "O'ZSMP", img: "/assets/img/partners/49-ozsmp.webp" },
    { name: "UNG Overseas", img: "/assets/img/partners/50-ung-overseas.webp" },
    { name: "Cleanza", img: "/assets/img/partners/55-cleanza.webp" },
    { name: "Scriber Engineering Arts", img: "/assets/img/partners/57-scriber-engineering-arts.webp" },
    { name: "Tax Advisors Academy", img: "/assets/img/partners/58-tax-advisors-academy.webp" },
    { name: "Decolor", img: "/assets/img/partners/59-decolor.webp" },
    { name: "Kuychi.AI", img: "/assets/img/partners/60-kuychiai.webp" },
]

export default dataPartner;
